export default __webpack_public_path__ + "static/media/llmIconRound.3151e7e6.svg";